import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Cta from "../components/Cta";
import { client } from "../config/prismic";

const Cfp = () => {
  const [sessions, setSessions] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("call_for_paper");
      setSessions(response.results); // Store the call for paper data
    };
    fetchData();
  }, []);

  if (!sessions) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  console.log(sessions); // For debugging

  // Function to render text with spans
  const renderTextWithSpans = (text, spans) => {
    let lastIndex = 0; // Keep track of the last index processed
    const elements = []; // Array to hold the JSX elements

    spans.forEach((span) => {
      // Push text before the current span
      if (span.start > lastIndex) {
        elements.push(text.slice(lastIndex, span.start));
      }

      // Determine the span type and create the corresponding element
      if (span.type === "strong") {
        elements.push(
          <strong key={`${span.start}-${span.end}`}>
            {text.slice(span.start, span.end)}
          </strong>
        );
      } else if (span.type === "hyperlink") {
        elements.push(
          <a
            key={`${span.start}-${span.end}`}
            href={span.data.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {text.slice(span.start, span.end)}
          </a>
        );
      }

      // Update lastIndex to the end of the current span
      lastIndex = span.end;
    });

    // Push any remaining text after the last span
    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }

    return elements;
  };

  console.log(sessions);

  return (
    <div>
      <Header page={true} />
      <Cta />
      <div class="sec-title3 text-center mt-5 pt-5">
        <span>Call for Papers</span>
        <h2>Call for Papers</h2>
      </div>
      <div className="container my-5">
        <div className="card shadow-lg">
          <div className="card-body">
            {sessions.map((session) => (
              <div key={session.id}>
                {session.data.description.map((desc, index) => (
                  <p key={index} className="card-text text-justify">
                    {renderTextWithSpans(desc.text, desc.spans)}
                  </p>
                ))}

                {session.data.dark_text.map((darkText, index) => (
                  <h5 key={index} className="card-text my-4 text-justify">
                    {renderTextWithSpans(darkText.text, darkText.spans)}
                  </h5>
                ))}

                <h3 className="text-center mt-4 pt-4">
                  <b>Instructions For Authors</b>
                </h3>
                <ul>
                  {session.data.instructions.map((instruction, index) => (
                    <li key={index} className="text-justify">
                      {renderTextWithSpans(instruction.text, instruction.spans)}
                    </li>
                  ))}
                </ul>

                <h3 className="text-center mt-4 pt-4">
                  <b>Copy Right Form:</b>
                </h3>
                <ul>
                  {session.data.copyright.map((copyRight, index) => (
                    <li key={index} className="text-justify">
                      {renderTextWithSpans(copyRight.text, copyRight.spans)}
                    </li>
                  ))}
                </ul>

                <p className="mt-4">
                  <strong>Useful Links:</strong>
                </p>
                {session.data.links.map((copyRight, index) => (
                  <p key={index} className="text-justify">
                    {renderTextWithSpans(copyRight.text, copyRight.spans)}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Cfp;
